import { Controller } from '@hotwired/stimulus';

// Message passager : retiré après `delay` ms (8 s ; sauf message persistant : erreur,
// réserve), compte suspendu tant que la souris le survole ou que le focus y
// est ; retiré aussi à la croix, ou avant la mise en cache Turbo (la page
// revenue ne le rejoue pas).
export default class extends Controller {
    static values = { persistent: Boolean, delay: { type: Number, default: 8000 } };

    connect() {
        this.remaining = this.delayValue;
        this.resume();
        this.cleanup = () => this.close();
        document.addEventListener('turbo:before-cache', this.cleanup);
    }

    pause() {
        if (!this.timer) return;
        clearTimeout(this.timer);
        this.timer = null;
        this.remaining -= Date.now() - this.started;
    }

    // Reprise quand ni la souris ni le focus ne sont plus sur le message.
    resume(event) {
        if (this.persistentValue || this.timer) return;
        if (event?.type === 'focusout' && (this.element.contains(event.relatedTarget) || this.element.matches(':hover'))) return;
        if (event?.type === 'mouseleave' && this.element.contains(document.activeElement)) return;
        this.started = Date.now();
        this.timer = setTimeout(() => this.close(), Math.max(this.remaining, 1000));
    }

    close() {
        this.element.remove();
    }

    disconnect() {
        clearTimeout(this.timer);
        this.timer = null;
        document.removeEventListener('turbo:before-cache', this.cleanup);
    }
}
